(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5568],{

/***/ 88593:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/extra/ssl-certificates",
      function () {
        return __webpack_require__(63882);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 63882:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ ssl_certificates; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(57135);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(72006);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(4405);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(59072);
// EXTERNAL MODULE: ./node_modules/.pnpm/tslib@2.4.1/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(80677);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(11527);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_react-dom@18.2.0_react@18.2.0/node_modules/next/head.js
var head = __webpack_require__(93834);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./layout/Layout/index.js + 9 modules
var Layout = __webpack_require__(4967);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_react-dom@18.2.0_react@18.2.0/node_modules/next/image.js
var next_image = __webpack_require__(70649);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/SSS/SSS.js
var SSS = __webpack_require__(14313);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-table@7.8.0_react@18.2.0/node_modules/react-table/index.js
var react_table = __webpack_require__(86716);
// EXTERNAL MODULE: ./components/FormElements/Button.js
var Button = __webpack_require__(62303);
// EXTERNAL MODULE: ./store/GlobalStore.js
var GlobalStore = __webpack_require__(36345);
// EXTERNAL MODULE: ./store/AuthStore.js
var AuthStore = __webpack_require__(57305);
// EXTERNAL MODULE: ./helpers/helpersFunc.js + 2 modules
var helpersFunc = __webpack_require__(65126);
// EXTERNAL MODULE: ./node_modules/.pnpm/next-i18next@13.0.2_i18next@22.4.6_next@12.3.4_react-i18next@12.1.1_react@18.2.0/node_modules/next-i18next/dist/esm/index.js + 11 modules
var esm = __webpack_require__(66264);
// EXTERNAL MODULE: ./store/ConfigurationStore.js
var ConfigurationStore = __webpack_require__(20363);
;// CONCATENATED MODULE: ./components/SSLCertificates/SSLTable.js













function SSLTable(param) {
    var datas = param.datas, onAddBasket = param.onAddBasket;
    var logo = function logo(props) {
        var SplitedName = props.cell.row.original.component.split(" ");
        if (SplitedName[0] === "RapidSSL") {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: "/RapidSSL.png",
                alt: "rapid-ssl",
                title: "Rapid SSL",
                width: "86",
                height: "22",
                quality: 100
            });
        } else if (SplitedName[0] === "Sectigo") {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: "/sectigo.png",
                width: "107",
                height: "20",
                alt: "sectigo",
                title: "Sectigo",
                quality: 100
            });
        } else if (SplitedName[0] === "GeoTrust") {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: "/geoTrust.png",
                width: "112",
                height: "20",
                alt: "geotrust",
                title: "Geotrust",
                quality: 100
            });
        } else if (SplitedName[0] === "GoGetSSL") {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: "/goGetSSL.svg",
                width: "104",
                height: "32",
                alt: "GoGetSSL",
                title: "GoGetSSL",
                quality: 100
            });
        } else {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: "/newSSL.png",
                width: "104",
                height: "28",
                alt: "newssl",
                title: "SSL",
                quality: 100
            });
        }
    };
    var thick = function thick(props) {
        // if (props.value === true) {
        //     return <svg className="mx-auto" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        //         <path d="M9 16.5C4.85775 16.5 1.5 13.1423 1.5 9C1.5 4.85775 4.85775 1.5 9 1.5C13.1423 1.5 16.5 4.85775 16.5 9C16.5 13.1423 13.1423 16.5 9 16.5ZM8.25225 12L13.5548 6.69675L12.4943 5.63625L8.25225 9.879L6.1305 7.75725L5.07 8.81775L8.25225 12Z" fill="#45D85B" />
        //     </svg>
        // }
        // else if (props.value === false) {
        //     return <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        //         <path d="M9 16.5C4.85775 16.5 1.5 13.1422 1.5 9C1.5 4.85775 4.85775 1.5 9 1.5C13.1422 1.5 16.5 4.85775 16.5 9C16.5 13.1422 13.1422 16.5 9 16.5ZM9 7.9395L6.879 5.81775L5.81775 6.879L7.9395 9L5.81775 11.121L6.879 12.1823L9 10.0605L11.121 12.1823L12.1823 11.121L10.0605 9L12.1823 6.879L11.121 5.81775L9 7.9395Z" fill="#FF433D" />
        //     </svg>
        // } else {
        //     return props.value
        // }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            className: "mx-auto",
            width: "18",
            height: "18",
            viewBox: "0 0 18 18",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9 16.5C4.85775 16.5 1.5 13.1423 1.5 9C1.5 4.85775 4.85775 1.5 9 1.5C13.1423 1.5 16.5 4.85775 16.5 9C16.5 13.1423 13.1423 16.5 9 16.5ZM8.25225 12L13.5548 6.69675L12.4943 5.63625L8.25225 9.879L6.1305 7.75725L5.07 8.81775L8.25225 12Z",
                fill: "#45D85B"
            })
        });
    };
    var tablePrice = function tablePrice(props) {
        var ref;
        var newPrice = (0,helpersFunc/* changeCurrency */.sy)(currencyRates, currencyType, props === null || props === void 0 ? void 0 : props.value.one_year, (ref = props.row.original) === null || ref === void 0 ? void 0 : ref.currency);
        var splitedPrice = newPrice.split(".");
        if (props) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "footerPrice",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "text-3xl font-medium text-titleColor",
                            children: [
                                splitedPrice[0],
                                "."
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col ml-1",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "p-0 m-0 text-sm text-titleColor",
                                    children: [
                                        splitedPrice[1],
                                        " ",
                                        currencyType
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "p-0 m-0 text-sm text-titleColor",
                                    children: t("common:yearly")
                                })
                            ]
                        })
                    ]
                })
            });
        }
    };
    var tableButton = function tableButton(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
            onClick: function() {
                return onAddBasket(props.cell.row.original);
            },
            name: props.cell.row.id,
            buttonText: t("common:addBasket"),
            buttonLeftIcon: "ri-add-fill"
        });
    };
    var t = (0,esm/* useTranslation */.$G)([
        "header",
        "nav",
        "ssl"
    ]).t;
    var ref = (0,_sliced_to_array/* default */.Z)((0,ConfigurationStore/* useConfigurationStore */.w)(function(state) {
        return [
            state.setSelectedServer
        ];
    }), 1), setDefaultPaymentCycle = ref[0];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,AuthStore/* useAuthStore */.t)(function(state) {
        return [
            state.isLoggin
        ];
    }), 1), isLoggin = ref1[0];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,GlobalStore/* useGlobalStore */.s)(function(state) {
        return [
            state.currencyType,
            state.currencyRates
        ];
    }), 2), currencyType = ref2[0], currencyRates = ref2[1];
    var data = react.useMemo(function() {
        var ref, ref1, ref2, ref3, ref4, ref5;
        if (((ref = datas[0]) === null || ref === void 0 ? void 0 : ref.one_month_price) > 0) {
            setDefaultPaymentCycle(1);
        } else if (((ref1 = datas[0]) === null || ref1 === void 0 ? void 0 : ref1.three_month_price) > 0) {
            setDefaultPaymentCycle(3);
        } else if (((ref2 = datas[0]) === null || ref2 === void 0 ? void 0 : ref2.six_month_price) > 0) {
            setDefaultPaymentCycle(6);
        } else if (((ref3 = datas[0]) === null || ref3 === void 0 ? void 0 : ref3.one_year_price) > 0) {
            setDefaultPaymentCycle(12);
        } else if (((ref4 = datas[0]) === null || ref4 === void 0 ? void 0 : ref4.two_year_price) > 0) {
            setDefaultPaymentCycle(24);
        } else if (((ref5 = datas[0]) === null || ref5 === void 0 ? void 0 : ref5.three_year_price) > 0) {
            setDefaultPaymentCycle(36);
        }
        return datas;
    }, []);
    var columns = react.useMemo(function() {
        return [
            {
                Header: "",
                accessor: "col1",
                Cell: logo
            },
            {
                Header: t("ssl:certificateName"),
                accessor: "component"
            },
            {
                Header: t("ssl:encryption"),
                accessor: "col3",
                Cell: function() {
                    return "128/256 Bit";
                }
            },
            {
                Header: t("ssl:freeInstallation"),
                accessor: "col4",
                Cell: thick
            },
            {
                Header: t("common:period"),
                accessor: "col5",
                Cell: function() {
                    return "1 " + t("common:year");
                }
            },
            {
                Header: t("common:price"),
                accessor: "price",
                Cell: tablePrice
            },
            {
                Header: "",
                accessor: "col7",
                Cell: tableButton
            }
        ];
    }, [
        currencyType,
        isLoggin
    ]);
    var ref3 = (0,react_table.useTable)({
        columns: columns,
        data: data
    }), getTableProps = ref3.getTableProps, getTableBodyProps = ref3.getTableBodyProps, headerGroups = ref3.headerGroups, rows = ref3.rows, prepareRow = ref3.prepareRow;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, getTableProps()), {
        className: "w-full",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                children: headerGroups.map(function(headerGroup) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, headerGroup.getHeaderGroupProps()), {
                        children: headerGroup.headers.map(function(column) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("th", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, column.getHeaderProps()), {
                                className: "p-3 text-sm text-left whitespace-nowrap bg-makdosTitleDiv text-textWhite",
                                children: column.render("Header")
                            }));
                        })
                    }));
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, getTableBodyProps()), {
                children: rows.map(function(row, index) {
                    prepareRow(row);
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, row.getRowProps()), {
                        className: index % 2 === 0 ? " bg-white p-3" : " bg-makdosSecondaryGray p-3",
                        children: row.cells.map(function(cell) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("td", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, cell.getCellProps()), {
                                className: "p-3 whitespace-nowrap",
                                children: cell.render("Cell")
                            }));
                        })
                    }));
                })
            }))
        ]
    }));
}
/* harmony default export */ var SSLCertificates_SSLTable = (SSLTable);

// EXTERNAL MODULE: ./services/allServices.js + 1 modules
var allServices = __webpack_require__(63700);
// EXTERNAL MODULE: ./components/SSLCertificates/SSLSelectProjectModal.js
var SSLSelectProjectModal = __webpack_require__(81775);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_react-dom@18.2.0_react@18.2.0/node_modules/next/router.js
var next_router = __webpack_require__(63498);
;// CONCATENATED MODULE: ./public/SSS/sss-tr-ssl-sertifikası.json
var sss_tr_ssl_sertifikas_namespaceObject = JSON.parse('{"SSL sertifikası nedir?":"SSL sertifikası, bir web sitesinin güvenliğini ve kullanıcıların kişisel bilgilerinin korunmasını sağlayan dijital bir sertifikadır. SSL, \'Secure Sockets Layer\' (Güvenli Yuva Katmanı) ifadesinin kısaltmasıdır.","Neden SSL sertifikası kullanmalıyım?":"SSL sertifikası, web sitenizin güvenliğini artırır, kullanıcı verilerini korur ve arama motorları tarafından daha iyi sıralamalar elde etmenizi sağlar. Ayrıca, ziyaretçilerin sitenizin güvenli olduğunu görmelerini sağlayarak güvenilirlik kazandırır.","SSL sertifikası çeşitleri nelerdir?":"SSL sertifikaları, doğrulama düzeyine göre üç ana kategoriye ayrılır: Domain Doğrulamalı (DV), Organizasyon Doğrulamalı (OV) ve Genişletilmiş Doğrulamalı (EV) sertifikalar.","SSL sertifikası nasıl kurulur?":"Makdos.com üzerinden satın alınan SSL sertifikaları, otomatik olarak web sitenize kurulur ve süreci sizin için yönetir.","SSL sertifikası fiyatları ne kadardır?":"SSL sertifikası fiyatları, sertifika türüne, sağlayıcıya ve süresine bağlı olarak değişir. Genellikle, DV sertifikaları en uygun fiyatlıdır, OV ve EV sertifikaları ise daha yüksek maliyetlidir.","SSL sertifikası ne kadar süreyle geçerlidir?":"SSL sertifikaları genellikle 1 ila 2 yıl arasında geçerlidir. Süre sonunda, sertifikayı yenilemeniz gerekmektedir.","SSL sertifikası nasıl yenilenir?":"SSL sertifikası yenileme süreci, ilk kez kurulum sürecine benzerdir. Yenileme işlemi genellikle Makdos teknik destek tarafından yönetilir.","SSL sertifikalarının avantajları nelerdir?":"SSL sertifikalarının avantajları arasında artan site güvenliği, kullanıcı verilerinin korunması, arama motoru sıralamalarında iyileşme ve müşteri güveninin artması bulunmaktadır.","SSL sertifikası olmayan bir site nasıl anlaşılır?":"SSL sertifikası olmayan bir site, tarayıcı adres çubuğunda \\"http://\\" ile başlar ve genellikle tarayıcıda güvensiz olarak işaretlenir.","SSL sertifikası hangi durumlarda gereklidir?":"SSL sertifikası, e-ticaret siteleri, üye girişi yapılan platformlar ve kişisel bilgi toplama amacıyla kullanılan tüm web siteleri için gereklidir.","SSL sertifikası alırken nelere dikkat etmeliyim?":"SSL sertifikası alırken, sertifika türüne, kurulum kolaylığına ve fiyat-performans oranına dikkat etmelisiniz.","SSL sertifikası site hızını etkiler mi?":"SSL sertifikası, veri şifreleme işlemi nedeniyle teorik olarak site hızını etkileyebilir. Ancak, modern teknolojiler ve optimize edilmiş sunucular sayesinde bu etki minimal düzeydedir.","SSL sertifikası mobil cihazlarda çalışır mı?":"Evet, SSL sertifikaları, tüm modern mobil cihazlarda ve tarayıcılarda çalışır.","SSL sertifikası ile ilgili teknik destek alabilir miyim?":"Evet, makdos.com üzerinden satın alınan SSL sertifikaları için teknik destek alabilirsiniz. Müşteri hizmetleri ekibimiz, SSL ile ilgili her türlü sorunuzda size yardımcı olmaktan mutluluk duyar.","Wildcard SSL sertifikası nedir?":"Wildcard SSL sertifikası, bir ana domain ve bu domainin altındaki tüm subdomain \'ler için geçerli olan bir SSL sertifikasıdır. Bu sayede, tek bir sertifika ile birden fazla subdomain \'i güvence altına alabilirsiniz.","EV SSL sertifikası nedir?":"EV SSL sertifikası, bir web sitesinin güvenliğini ve güvenilirliğini artırmak için kullanılan, en üst düzey doğrulama sürecine sahip bir SSL sertifikası türüdür. Bu sertifika türü, web sitesinin sahibinin kimliğini doğrulamak için daha kapsamlı bir süreç gerektirir. Bu sayede, kullanıcılar web sitesinin güvenilir ve meşru bir işletmeye ait olduğundan emin olabilirler. EV SSL sertifikaları, kullanıcıların tarayıcısında yeşil bir adres çubuğu ve şirketin adını göstererek daha yüksek bir güven düzeyi sunar. Bu özellikler, kullanıcıların phishing ve sahte web sitelerine karşı korunmasına yardımcı olur ve web sitesi sahiplerinin marka değerini artırır. Özellikle finans, e-ticaret ve hassas bilgilerin işlendiği sektörlerde tercih edilen EV SSL sertifikaları, kullanıcıların güvenini kazanmak için önemli bir araçtır."}');
;// CONCATENATED MODULE: ./public/SSS/sss-en-ssl-sertifikası.json
var sss_en_ssl_sertifikas_namespaceObject = JSON.parse('{"What is an SSL certificate?":"An SSL certificate is a digital certificate that ensures the security of a website and the protection of users\' personal information. SSL stands for \'Secure Sockets Layer\'.","Why should I use an SSL certificate?":"An SSL certificate increases the security of your website, protects user data and allows you to achieve better rankings by search engines. It also builds credibility by letting visitors see that your site is secure.","What are the types of SSL certificates?":"SSL certificates are divided into three main categories according to the level of validation: Domain Validated (DV), Organization Validated (OV) and Extended Validated (EV) certificates.","How to install an SSL certificate?":"SSL certificates purchased through makdos.com are automatically installed on your website and manage the process for you.","How much do SSL certificates cost?":"SSL certificate prices vary depending on the certificate type, provider and duration. Generally, DV certificates are the most affordable, while OV and EV certificates are more costly.","How long is an SSL certificate valid?":"SSL certificates are usually valid for 1 to 2 years. At the end of the period, you need to renew the certificate.","How to renew an SSL certificate?":"The SSL certificate renewal process is similar to the first time installation process. The renewal process is usually managed by Makdos technical support.","What are the benefits of SSL certificates?":"The benefits of SSL certificates include increased site security, protection of user data, improved search engine rankings and increased customer confidence.","How to recognize a site without an SSL certificate?":"A site without an SSL certificate starts with \\"http://\\" in the browser address bar and is usually marked as insecure in the browser.","In which cases is an SSL certificate required?":"SSL certificates are required for e-commerce sites, member login platforms and all websites used to collect personal information.","What should I look for when buying an SSL certificate?":"When buying an SSL certificate, you should pay attention to the certificate type, ease of installation and price-performance ratio.","Does an SSL certificate affect site speed?":"An SSL certificate can theoretically affect site speed due to the data encryption process. However, thanks to modern technologies and optimized servers, this impact is minimal.","Does an SSL certificate work on mobile devices?":"Yes, SSL certificates work on all modern mobile devices and browsers.","Can I get technical support for SSL certificates?":"Yes, you can get technical support for SSL certificates purchased through makdos.com. Our customer service team is happy to help you with any SSL-related questions you may have.","What is a Wildcard SSL certificate?":"A Wildcard SSL certificate is an SSL certificate that is valid for a main domain and all subdomains under that domain. This way, you can secure multiple subdomains with a single certificate.","What is an EV SSL certificate?":"An EV SSL certificate is a type of SSL certificate with the highest level of validation process, used to increase the security and reliability of a website. This type of certificate requires a more thorough process to verify the identity of the owner of the website. This way, users can be sure that the website belongs to a reliable and legitimate business. EV SSL certificates offer a higher level of trust by displaying a green address bar and the company \'s name in users\' browser. These features help protect users against phishing and fake websites and increase the brand value of website owners. EV SSL certificates, which are especially preferred in finance, e-commerce and sectors where sensitive information is processed, are an important tool to gain the trust of users."}');
// EXTERNAL MODULE: ./helpers/googleEvents.js
var googleEvents = __webpack_require__(41804);
;// CONCATENATED MODULE: ./pages/extra/ssl-certificates.js






















function sslcertificates(param) {
    var datas = param.datas, rates = param.rates;
    var ref = (0,_sliced_to_array/* default */.Z)((0,AuthStore/* useAuthStore */.t)(function(state) {
        return [
            state.isLoggin,
            state.setIsLoggin,
            state.setLogginOpen
        ];
    }), 3), isLoggin = ref[0], setIsLoggin = ref[1], setLogginOpen = ref[2];
    var t = (0,esm/* useTranslation */.$G)([
        "common"
    ]).t;
    var router = (0,next_router.useRouter)();
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,GlobalStore/* useGlobalStore */.s)(function(state) {
        return [
            state.currencyType,
            state.currencyRates,
            state.setCurrencyRates
        ];
    }), 3), currencyType = ref1[0], currencyRates = ref1[1], setCurrencyRates = ref1[2];
    var ref2 = (0,react.useState)(), sslList = ref2[0], setsslList = ref2[1];
    var ref3 = (0,react.useState)(), allData = ref3[0], setAllData = ref3[1];
    var ref4 = (0,react.useState)(0), selectedTab = ref4[0], setSelectedTab = ref4[1];
    var ref5 = (0,react.useState)(), selectedTabData = ref5[0], setSelectedTabData = ref5[1];
    var ref6 = (0,react.useState)(false), openModal = ref6[0], setOpenModal = ref6[1];
    var ref7 = (0,react.useState)(), selectedProject = ref7[0], setSelectedProject = ref7[1];
    var ref8 = (0,react.useState)(), projectList = ref8[0], setProjectList = ref8[1];
    var ref9 = (0,react.useState)(), projectNameList = ref9[0], setProjectNameList = ref9[1];
    var onListSSLCertificate = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var newList;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setAllData(datas);
                        newList = [];
                        return [
                            4,
                            datas.map(function() {
                                var _ref = (0,_async_to_generator/* default */.Z)(function(item) {
                                    var ref;
                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                        item === null || item === void 0 ? void 0 : (ref = item.available_components) === null || ref === void 0 ? void 0 : ref.sort(function(a, b) {
                                            return a.price.one_year - b.price.one_year;
                                        }).map(function(ssl) {
                                            newList.push((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, ssl), {
                                                product_id: item.id
                                            }));
                                        });
                                        return [
                                            2
                                        ];
                                    });
                                });
                                return function(item) {
                                    return _ref.apply(this, arguments);
                                };
                            }())
                        ];
                    case 1:
                        _state.sent();
                        setsslList(newList);
                        return [
                            2
                        ];
                }
            });
        });
        return function onListSSLCertificate() {
            return _ref.apply(this, arguments);
        };
    }();
    var onSetSelectedTab = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(i) {
            var filteredData;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setSelectedTab(i);
                        if (!(i > 0)) return [
                            3,
                            2
                        ];
                        filteredData = allData.find(function(x) {
                            return x.id === i;
                        }).available_components;
                        return [
                            4,
                            setSelectedTabData()
                        ];
                    case 1:
                        _state.sent();
                        setSelectedTabData(filteredData);
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        return function onSetSelectedTab(i) {
            return _ref.apply(this, arguments);
        };
    }();
    var onAddBasketBefore = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(selectedData) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                if (isLoggin) {
                    setOpenModal(selectedData);
                } else {
                    setLogginOpen(true);
                }
                return [
                    2
                ];
            });
        });
        return function onAddBasketBefore(selectedData) {
            return _ref.apply(this, arguments);
        };
    }();
    var onAddBasket = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(selectedData, params) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!isLoggin) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            (0,allServices/* checkAddBasket */.Jq)().then(function() {
                                var _ref = (0,_async_to_generator/* default */.Z)(function(isAddBasket) {
                                    var ref, productID, totalPrice, totalPriceWithOutKdv, basketId, currency, configureAvailable;
                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                if (!isAddBasket.status) return [
                                                    3,
                                                    2
                                                ];
                                                productID = selectedTab !== 0 ? selectedTab : selectedData === null || selectedData === void 0 ? void 0 : selectedData.product_id;
                                                totalPrice = (0,helpersFunc/* changeCurrency */.sy)(currencyRates, currencyType, parseFloat(selectedData.price.one_year * 0.20 + selectedData.price.one_year).toFixed(2));
                                                totalPriceWithOutKdv = (0,helpersFunc/* changeCurrency */.sy)(currencyRates, currencyType, selectedData.price.one_year, selectedData.currency);
                                                basketId = 0;
                                                currency = (ref = currencyRates.find(function(x) {
                                                    return x.symbol === currencyType;
                                                })) === null || ref === void 0 ? void 0 : ref.currency_type;
                                                configureAvailable = {
                                                    component_type_id: 22,
                                                    component_id: selectedData.component_id,
                                                    quantity: 1,
                                                    payment_cycle: 12
                                                };
                                                return [
                                                    4,
                                                    (0,allServices/* addProductBasketSSL */.U5)(productID, 12, selectedProject.id, totalPriceWithOutKdv, "", params === null || params === void 0 ? void 0 : params.hostname, configureAvailable, currency).then(function(data) {
                                                        basketId = data.basket_ssl_product_id;
                                                        (0,googleEvents/* googleEventAddBasketSSL */.is)(selectedData, totalPriceWithOutKdv, currency, 12, basketId);
                                                    })
                                                ];
                                            case 1:
                                                _state.sent();
                                                router.push(t("nav:basket"));
                                                return [
                                                    3,
                                                    3
                                                ];
                                            case 2:
                                                alert("\xd6denmemiş proformanız vardır. Sepet oluşturamazsınız.");
                                                _state.label = 3;
                                            case 3:
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                                return function(isAddBasket) {
                                    return _ref.apply(this, arguments);
                                };
                            }())
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        setLogginOpen(true);
                        _state.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function onAddBasket(selectedData, params) {
            return _ref.apply(this, arguments);
        };
    }();
    var onGetProjectList = function() {
        (0,allServices/* getProjectList */.ku)().then(function(data) {
            setProjectList(data);
            var nameList = [];
            data.map(function(item) {
                nameList.push(item.name);
                if (item.default_project === true) {
                    setSelectedProject(item);
                }
            });
            setProjectNameList(nameList);
        }).catch(function(err) {
            var ref;
            if ((err === null || err === void 0 ? void 0 : (ref = err.request) === null || ref === void 0 ? void 0 : ref.status) === 401) {
                setIsLoggin(false);
            }
        });
    };
    var onSetSelectedProject = function(item) {
        if (item) {
            projectList.map(function(prj) {
                if (prj.name === item) {
                    setSelectedProject(prj);
                }
            });
        }
    };
    (0,react.useEffect)(function() {
        onListSSLCertificate();
    }, []);
    (0,react.useEffect)(function() {
        if (isLoggin) {
            onGetProjectList();
        }
    }, [
        isLoggin
    ]);
    (0,react.useEffect)(function() {
        setCurrencyRates(rates);
    }, [
        rates
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: t("sslMetaTitle")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: t("sslMetaDescription")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: t("sslMetaTitle")
                    }, "title"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: t("sslMetaDescription")
                    }, "description")
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full bg-no-repeat transform-gpu bg-SSLBg",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container px-4 pt-20 pb-20 mx-auto lg:px-0",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex justify-between mb-14",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex-1",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-xl",
                                            children: t("ssl:title")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                            className: "my-3 text-5xl font-semibold",
                                            children: t("ssl:title2")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: t("ssl:description")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "hidden flex-1 justify-end lg:flex",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: "/sslImage.svg",
                                        alt: "ssl",
                                        title: "ssl",
                                        width: "327",
                                        height: "110",
                                        priority: true,
                                        loading: "eager",
                                        className: "transform-gpu"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "overflow-x-auto p-8 mb-20 bg-white rounded-md shadow-lg",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex justify-between items-center mb-6",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-2xl font-medium text-titleColor",
                                            children: t("ssl:sslCertificate")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex items-center",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    onClick: function() {
                                                        return onSetSelectedTab(0);
                                                    },
                                                    className: "px-5 py-2  ml-4 rounded-full cursor-pointer border ".concat(selectedTab === 0 ? "bg-makdosYellow border-makdosYellow" : "bg-white border border-makdosSecondaryGray hover:bg-makdosYellow transition-all duration-300"),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "font-semibold text-titleColor",
                                                        children: t("ssl:allCertificate")
                                                    })
                                                }),
                                                allData && allData.map(function(item, index) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        onClick: function() {
                                                            return onSetSelectedTab(item.id);
                                                        },
                                                        className: "px-5 py-2  ml-4 rounded-full cursor-pointer border ".concat(selectedTab === item.id ? "bg-makdosYellow border-makdosYellow" : "bg-white border border-makdosSecondaryGray hover:bg-makdosYellow transition-all duration-300"),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "font-semibold text-titleColor",
                                                            children: item.product_name
                                                        })
                                                    }, index + 1);
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                sslList && selectedTab === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(SSLCertificates_SSLTable, {
                                    datas: sslList,
                                    onAddBasket: function(v) {
                                        return onAddBasketBefore(v);
                                    }
                                }),
                                selectedTabData && selectedTab !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(SSLCertificates_SSLTable, {
                                    datas: selectedTabData,
                                    onAddBasket: function(v) {
                                        return onAddBasketBefore(v);
                                    }
                                }),
                                openModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(SSLSelectProjectModal/* default */.Z, {
                                    type: "ssl",
                                    setOpenModal: function() {
                                        return setOpenModal(false);
                                    },
                                    onClick: function(v, p) {
                                        return onAddBasket(v, p);
                                    },
                                    selectedData: openModal,
                                    selectedProject: selectedProject,
                                    onSetSelectedProject: function(v) {
                                        return onSetSelectedProject(v);
                                    },
                                    projectNameList: projectNameList
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "grid grid-cols-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex col-span-2 items-center lg:col-span-1",
                                    children: router.locale === "tr" ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: "/sslSertifika.png",
                                        alt: "ssl-certificate",
                                        title: "ssl-certificate",
                                        width: "515",
                                        height: "504"
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: "/sslSertifikaEN.png",
                                        alt: "ssl-certificate",
                                        title: "ssl-certificate",
                                        width: "515",
                                        height: "504"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "col-span-2 pr-16 lg:col-span-1",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            className: "mb-5 text-4xl font-semibold text-titleColor font",
                                            children: t("ssl:sslParagraphTitle")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-sm text-cardText",
                                            children: t("ssl:sslParagraphDescription1")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-sm text-cardText",
                                            children: t("ssl:sslParagraphDescription2")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: "text-sm text-cardText",
                                            children: [
                                                t("ssl:sslParagraphDescription3"),
                                                " "
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-xl font-semibold text-titleColor",
                                            children: t("ssl:thisTypeSSL")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "mt-4",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex items-center mb-3",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                            width: "18",
                                                            height: "18",
                                                            viewBox: "0 0 18 18",
                                                            fill: "none",
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                d: "M9 16.5C4.85775 16.5 1.5 13.1422 1.5 9C1.5 4.85775 4.85775 1.5 9 1.5C13.1422 1.5 16.5 4.85775 16.5 9C16.5 13.1422 13.1422 16.5 9 16.5ZM8.25225 12L13.5547 6.69675L12.4943 5.63625L8.25225 9.879L6.1305 7.75725L5.07 8.81775L8.25225 12Z",
                                                                fill: "#45D85B"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "ml-2 text-cardText text-md",
                                                            children: t("ssl:sslType1")
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex items-center mb-3",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                            width: "18",
                                                            height: "18",
                                                            viewBox: "0 0 18 18",
                                                            fill: "none",
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                d: "M9 16.5C4.85775 16.5 1.5 13.1422 1.5 9C1.5 4.85775 4.85775 1.5 9 1.5C13.1422 1.5 16.5 4.85775 16.5 9C16.5 13.1422 13.1422 16.5 9 16.5ZM8.25225 12L13.5547 6.69675L12.4943 5.63625L8.25225 9.879L6.1305 7.75725L5.07 8.81775L8.25225 12Z",
                                                                fill: "#45D85B"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "ml-2 text-cardText text-md",
                                                            children: t("ssl:sslType2")
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex items-center mb-3",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                            width: "18",
                                                            height: "18",
                                                            viewBox: "0 0 18 18",
                                                            fill: "none",
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                d: "M9 16.5C4.85775 16.5 1.5 13.1422 1.5 9C1.5 4.85775 4.85775 1.5 9 1.5C13.1422 1.5 16.5 4.85775 16.5 9C16.5 13.1422 13.1422 16.5 9 16.5ZM8.25225 12L13.5547 6.69675L12.4943 5.63625L8.25225 9.879L6.1305 7.75725L5.07 8.81775L8.25225 12Z",
                                                                fill: "#45D85B"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "ml-2 text-cardText text-md",
                                                            children: t("ssl:sslType3")
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex items-center mb-3",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                            width: "18",
                                                            height: "18",
                                                            viewBox: "0 0 18 18",
                                                            fill: "none",
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                d: "M9 16.5C4.85775 16.5 1.5 13.1422 1.5 9C1.5 4.85775 4.85775 1.5 9 1.5C13.1422 1.5 16.5 4.85775 16.5 9C16.5 13.1422 13.1422 16.5 9 16.5ZM8.25225 12L13.5547 6.69675L12.4943 5.63625L8.25225 9.879L6.1305 7.75725L5.07 8.81775L8.25225 12Z",
                                                                fill: "#45D85B"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "ml-2 text-cardText text-md",
                                                            children: t("ssl:sslType4")
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex items-center mb-3",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                            width: "18",
                                                            height: "18",
                                                            viewBox: "0 0 18 18",
                                                            fill: "none",
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                d: "M9 16.5C4.85775 16.5 1.5 13.1422 1.5 9C1.5 4.85775 4.85775 1.5 9 1.5C13.1422 1.5 16.5 4.85775 16.5 9C16.5 13.1422 13.1422 16.5 9 16.5ZM8.25225 12L13.5547 6.69675L12.4943 5.63625L8.25225 9.879L6.1305 7.75725L5.07 8.81775L8.25225 12Z",
                                                                fill: "#45D85B"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "ml-2 text-cardText text-md",
                                                            children: t("ssl:sslType5")
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex items-center mb-3",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                            width: "18",
                                                            height: "18",
                                                            viewBox: "0 0 18 18",
                                                            fill: "none",
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                d: "M9 16.5C4.85775 16.5 1.5 13.1422 1.5 9C1.5 4.85775 4.85775 1.5 9 1.5C13.1422 1.5 16.5 4.85775 16.5 9C16.5 13.1422 13.1422 16.5 9 16.5ZM8.25225 12L13.5547 6.69675L12.4943 5.63625L8.25225 9.879L6.1305 7.75725L5.07 8.81775L8.25225 12Z",
                                                                fill: "#45D85B"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "ml-2 text-cardText text-md",
                                                            children: t("ssl:sslType6")
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SSS/* default */.Z, {
                data: router.locale === "tr" ? sss_tr_ssl_sertifikas_namespaceObject : sss_en_ssl_sertifikas_namespaceObject
            })
        ]
    });
}
var __N_SSP = true;
/* harmony default export */ var ssl_certificates = (sslcertificates);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2658,6716,4967,1804,2965,9774,2888,179], function() { return __webpack_exec__(88593); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);